<template>
 <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
    <div class="heig-frame-equipment-group mb-10 d-flex justify-content-center align-items-center">
      <b-row>
        <b-col md="12">
          <div class="lock"></div>
          <div class="clearfix text-center">
            <h1 class="display-3">
              <strong class="c-orange">403 - ACCESS DENIED</strong>
            </h1>
            
            <h3 class="text-muted">Oops, You don't have permission to access <strong><u>{{ $route.query && $route.query.page ? $route.query.page : 'this' }}</u></strong> page.</h3>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page403'
}
</script>
<style lang="scss" scoped>
  .lock {
    border-radius: 5px;
    width: 55px;
    height: 45px;
    background-color: #333;
    animation: dip 1s;
    animation-delay: (2s - .5);
    margin: auto;
    
    &::before,
    &::after {
      content: '';
      position: absolute;
      border-left: 5px solid #333;
      height: 20px;
      width: 25px;
      left: calc(50% - 12.5px);
    }
    
    &::before {
      top: -30px;
      border: 5px solid #333;
      border-bottom-color: transparent;
      border-radius: 15px 15px 0 0;
      height: 40px;
      animation: lock 2s, spin 2s;
    }
    
    &::after {
      top: -10px; 
      border-right: 5px solid transparent;
      animation: spin 2s;
    }
  }

  @keyframes lock {
    0% {
      top: -45px;
    }
    65% {
      top: -45px;
    }
    100% {
      top: -30px;
    }
  }

  @keyframes spin {
    0% {
      transform: scaleX(-1);
      left: calc(50% - 30px);
    }
    65% {
      transform: scaleX(1);
      left: calc(50% - 12.5px);
    }
  }

  @keyframes dip {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(10px);
    }
    100% {
      transform: translateY(0px);
    }
  }

</style>
